import React from 'react';
// import Lottie from 'react-lottie';
import './Success_Lottie.css';
import * as animationData from './Success_Lottie.json';
import Lottie from 'lottie-react';

function Success_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Success_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Success_Lottie;